var cov_11besjyznn = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/File.tsx",
      hash = "2e5f200ad5917617ad136ef7a87039f1f19ddd6e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/File.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 13,
          column: 9
        }
      },
      "1": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 16
        }
      },
      "2": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 52
        }
      },
      "3": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 38
        }
      },
      "4": {
        start: {
          line: 27,
          column: 47
        },
        end: {
          line: 27,
          column: 57
        }
      },
      "5": {
        start: {
          line: 28,
          column: 22
        },
        end: {
          line: 28,
          column: 75
        }
      },
      "6": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 48,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 32
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 17
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 22
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 11
          },
          end: {
            line: 49,
            column: 3
          }
        },
        line: 26
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 47
          },
          end: {
            line: 28,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 47
          },
          end: {
            line: 28,
            column: 63
          }
        }, {
          start: {
            line: 28,
            column: 67
          },
          end: {
            line: 28,
            column: 74
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 34,
            column: 11
          },
          end: {
            line: 34,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 11
          },
          end: {
            line: 34,
            column: 31
          }
        }, {
          start: {
            line: 34,
            column: 35
          },
          end: {
            line: 34,
            column: 39
          }
        }],
        line: 34
      },
      "2": {
        loc: {
          start: {
            line: 34,
            column: 49
          },
          end: {
            line: 34,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 49
          },
          end: {
            line: 34,
            column: 56
          }
        }, {
          start: {
            line: 34,
            column: 60
          },
          end: {
            line: 34,
            column: 85
          }
        }],
        line: 34
      },
      "3": {
        loc: {
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 46,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 9
          },
          end: {
            line: 39,
            column: 25
          }
        }, {
          start: {
            line: 40,
            column: 10
          },
          end: {
            line: 45,
            column: 12
          }
        }],
        line: 39
      },
      "4": {
        loc: {
          start: {
            line: 42,
            column: 24
          },
          end: {
            line: 42,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 39
          },
          end: {
            line: 42,
            column: 48
          }
        }, {
          start: {
            line: 42,
            column: 51
          },
          end: {
            line: 42,
            column: 64
          }
        }],
        line: 42
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Upload/File.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { uploadClass } from './styles';
import Progress from '../Progress';
import Spin from '../Spin';
import icons from '../icons';
import { ERROR, UPLOADING } from './request';
import { getDirectionClass } from '../utils/classname';
var SPIN = (cov_11besjyznn.s[0]++,
/*#__PURE__*/
React.createElement("span", {
  style: {
    display: 'inline-block',
    marginRight: 8
  },
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 3
  }
},
/*#__PURE__*/
React.createElement(Spin, {
  size: 10,
  name: "ring",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 12,
    columnNumber: 5
  }
})));

var File =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(File, _PureComponent);

  var _super = _createSuper2(File);

  function File(props) {
    var _this;

    _classCallCheck(this, File);

    cov_11besjyznn.f[0]++;
    cov_11besjyznn.s[1]++;
    _this = _super.call(this, props);
    cov_11besjyznn.s[2]++;
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(File, [{
    key: "handleRemove",
    value: function handleRemove() {
      cov_11besjyznn.f[1]++;
      cov_11besjyznn.s[3]++;
      this.props.onRemove(this.props.id);
    }
  }, {
    key: "render",
    value: function render() {
      cov_11besjyznn.f[2]++;

      var _ref = (cov_11besjyznn.s[4]++, this.props),
          message = _ref.message,
          name = _ref.name,
          status = _ref.status,
          process = _ref.process;

      var className = (cov_11besjyznn.s[5]++, uploadClass('view-file', (cov_11besjyznn.b[0][0]++, status === ERROR) && (cov_11besjyznn.b[0][1]++, 'error')));
      cov_11besjyznn.s[6]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 31,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass(getDirectionClass('text')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 32,
            columnNumber: 9
          }
        }, (cov_11besjyznn.b[1][0]++, status === UPLOADING) && (cov_11besjyznn.b[1][1]++, SPIN), " ", name, " ", (cov_11besjyznn.b[2][0]++, message) && (cov_11besjyznn.b[2][1]++,
        /*#__PURE__*/
        React.createElement("span", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 34,
            columnNumber: 61
          }
        }, "(", message, ") "))),
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('delete'),
          onClick: this.handleRemove,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 36,
            columnNumber: 9
          }
        }, icons.Close), (cov_11besjyznn.b[3][0]++, status !== ERROR) && (cov_11besjyznn.b[3][1]++,
        /*#__PURE__*/
        React.createElement(Progress, {
          className: uploadClass('progress'),
          background: process >= 0 ? (cov_11besjyznn.b[4][0]++, '#e9ecef') : (cov_11besjyznn.b[4][1]++, 'transparent'),
          value: process,
          strokeWidth: 2,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 40,
            columnNumber: 11
          }
        })))
      );
    }
  }]);

  return File;
}(PureComponent);

export default File;